






















































import axios from 'axios';
import { Endpoints } from '@/ts/store/Constants';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component({
    components: {
        DatePicker,
    },
})
export default class DownloadOfferReportForm extends Mixins(LocalizationMethods) {
    public startTime: string | null = null;
    public endTime: string | null = null;

    @Prop() public value: any;

    get dialog() {
        return this.value;
    }

    set dialog(value) {
        this.$emit('input', value);
    }

    public download() {
        axios({
            url: Endpoints.Admin.WaitingList.OFFER_STATUS_REPORT(),
            method: 'POST',
            data: {
                startTime: this.startTime,
                endTime: this.endTime,
            },
            responseType: 'blob',
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'offer-report.xlsx');
            document.body.appendChild(link);
            link.click();
        }).finally(() => {
            this.dialog = false;
        });
    }
}
